import React from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

// Status configuration with translation keys
const statusConfig = {
  quote: {
    labelKey: 'status.quote',
    color: '#805ad5',
    bg: '#f5f0ff',
  },
  planned: {
    labelKey: 'status.planned',
    color: '#f6ad55',
    bg: '#fef3e2',
  },
  in_progress: {
    labelKey: 'status.in_progress',
    color: '#4299e1',
    bg: '#ebf4ff',
  },
  completed: {
    labelKey: 'status.completed',
    color: '#48bb78',
    bg: '#e6ffed',
  },
  picked_up: {
    labelKey: 'status.picked_up',
    color: '#9f7aea',
    bg: '#f3e8ff',
  },
  cancelled: {
    labelKey: 'status.cancelled',
    color: '#fc8181',
    bg: '#fee2e2',
  },
  waiting: {
    labelKey: 'status.waiting',
    color: '#ed8936',
    bg: '#fef3e2',
  },
  vehicle_in_workshop: {
    labelKey: 'status.vehicle_in_workshop',
    color: '#0d9488',
    bg: '#ccfbf1',
  },
};

export default function StatusBadge({ status, detail, size = 'medium', 'data-testid': testId }) {
  const { t } = useTranslation();
  const config = statusConfig[status] || statusConfig.planned;

  const sizeStyles = {
    small: {
      fontSize: '11px',
      padding: '2px 8px',
      dotSize: 5,
    },
    medium: {
      fontSize: '13px',
      padding: '4px 12px',
      dotSize: 6,
    },
    large: {
      fontSize: '14px',
      padding: '6px 14px',
      dotSize: 7,
    },
  };

  const currentSize = sizeStyles[size] || sizeStyles.medium;

  return (
    <Box
      component="span"
      data-testid={testId}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        padding: currentSize.padding,
        borderRadius: '20px',
        fontSize: currentSize.fontSize,
        fontWeight: 500,
        backgroundColor: config.bg,
        color: config.color,
        fontFamily: "'Plus Jakarta Sans', sans-serif",
        whiteSpace: 'nowrap',
      }}
    >
      <Box
        component="span"
        sx={{
          width: currentSize.dotSize,
          height: currentSize.dotSize,
          borderRadius: '50%',
          backgroundColor: config.color,
        }}
      />
      {detail ? `${t(config.labelKey)} — ${detail}` : t(config.labelKey)}
    </Box>
  );
}

// Export config for use in other components
export { statusConfig };
